export default "__VITE_ASSET__173fcc3f__"